/** Shopper KYC vendor — mirrors backend SHOPPER_KYC_PROVIDER (default: sumsub). */
const KYC_PROVIDER_AMLBOT = "amlbot";
const KYC_PROVIDER_SUMSUB = "sumsub";

/**
 * Resolve active KYC provider from env. Only explicit `amlbot` enables AMLBot.
 */
export function resolveKycProvider() {
  const raw = (process.env.VUE_APP_KYC_PROVIDER || "").trim().toLowerCase();
  if (raw === KYC_PROVIDER_AMLBOT) {
    return KYC_PROVIDER_AMLBOT;
  }
  return KYC_PROVIDER_SUMSUB;
}

export function isAmlbotKycProvider() {
  return resolveKycProvider() === KYC_PROVIDER_AMLBOT;
}

export function isSumsubKycProvider() {
  return !isAmlbotKycProvider();
}
